import React, { useEffect, useState } from 'react';
import { verifyEmail } from '../services/publicService';
import './LoginPage.css';

export default function VerifyEmailPage() {
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const email = params.get('email');

    if (!token || !email) {
      setStatus('error');
      setMessage('Link inválido. Parâmetros ausentes.');
      return;
    }

    verifyEmail(token, email)
      .then(data => {
        setStatus('success');
        setMessage(data.message || 'E-mail verificado com sucesso!');
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Link inválido ou expirado.');
      });
  }, []);

  return (
    <div className="lp-root">
      <div className="lp-desktop" style={{ minHeight: '100vh' }}>
        <div className="lp-panel-left">
          <div className="lp-brand">
            <div className="lp-brand-logo">&#128188;</div>
            <div className="lp-brand-title">Conta<br />Blue</div>
            <div className="lp-brand-subtitle">
              Controle completo das finanças da sua empresa em um só lugar.
            </div>
          </div>
        </div>

        <div className="lp-panel-right">
          <div className="lp-form-box" style={{ textAlign: 'center' }}>
            {status === 'loading' && (
              <>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⏳</div>
                <h2>Verificando...</h2>
                <p>Aguarde enquanto confirmamos seu e-mail.</p>
              </>
            )}

            {status === 'success' && (
              <>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✅</div>
                <h2 style={{ color: '#065f46' }}>E-mail confirmado!</h2>
                <p>{message}</p>
                <p style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.5rem' }}>
                  Verifique sua caixa de entrada para o e-mail de criação de senha.
                </p>
                <a href="/login" className="lp-submit" style={{ display: 'inline-block', marginTop: '1.5rem', textDecoration: 'none', padding: '0.78rem 2rem' }}>
                  Ir para o Login
                </a>
              </>
            )}

            {status === 'error' && (
              <>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>❌</div>
                <h2 style={{ color: '#991b1b' }}>Link inválido</h2>
                <p>{message}</p>
                <p style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.5rem' }}>
                  O link pode ter expirado (válido por 60 minutos). Tente se cadastrar novamente.
                </p>
                <a href="/login" className="lp-submit" style={{ display: 'inline-block', marginTop: '1.5rem', textDecoration: 'none', padding: '0.78rem 2rem' }}>
                  Voltar ao Login
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
